import { Fragment } from 'react';
import { MINIMUM_EVENT_HEIGHT } from '../../../constants';
import type { CalendarEvent, RenderEvent } from '../../../types';
import { EventItem } from '../../event-item';
import { useOrganizeEventSpansIntoRows } from './hooks';
import styles from './week-events.module.css';

type Properties<T extends CalendarEvent> = {
  days: Date[];
  events: T[];
  renderEvent?: RenderEvent<T>;
};
export const WeekEvents = <T extends CalendarEvent>({ days, events, renderEvent }: Properties<T>) => {
  const organizeEventSpansIntoRows = useOrganizeEventSpansIntoRows<T>({ days, events });

  return (
    <>
      {days.map((day) => (
        <div className={styles['all-day-day-column']} key={`all-day-events-${day.toISOString()}`} />
      ))}
      {organizeEventSpansIntoRows.map((row, rowIndex) =>
        row.map(({ endDayIndex, event, startDayIndex }) => {
          const gridColumnStart = startDayIndex + 1;
          const gridColumnEnd = endDayIndex + 2; // +2 because grid-column-end is exclusive

          const eventItemComponent = <EventItem<T> calendarEvent={event} key={event.id} type="all-day" />;

          return (
            <Fragment key={`all-day-multi-day-event-${event.id}`}>
              {renderEvent
                ? renderEvent({
                    children: (
                      <div
                        className={styles['all-day-multi-day-event']}
                        style={{
                          gridColumn: `${gridColumnStart} / ${gridColumnEnd}`,
                          top: `${rowIndex * MINIMUM_EVENT_HEIGHT}px`,
                        }}
                      >
                        {eventItemComponent}
                      </div>
                    ),
                    event,
                  })
                : eventItemComponent}
            </Fragment>
          );
        }),
      )}
    </>
  );
};
